import React, { useState } from 'react';
import FeatureTabs, { CarouselControls } from '../utils/FeatureTab';
import { multiplayerData, multiplayerTabFeature, spatialAiTabFeature } from '../utils/constant';
import { CTABanner, SuperChargeCard, ToolsCard } from '../components/ui/UtilsLayout';
import { videoPath } from '../utils/imagePath';
import SignupModal from '../components/SignupModal';

export default function MUltiplayer() {
  const [showSignupModal, setShowSignupModal] = useState(false);
    const [activeFeatureIndex, setActiveFeatureIndex] = useState(0);
  
  return (
    <div className="bg-[#121316] flex flex-col">
      {/* HERO SECTION */}
      <section className="relative px-8 pt-28 md:pt-40 w-full max-w-[1500px] mx-auto">
        <div className="text-center space-y-6">
          <h1 className="text-2xl md:text-4xl font-bold text-[#D8D8D8] tracking-tight">
            Live Multiplayer Interaction in Shared Mixed Realities
          </h1>
          <p className="text-[20px] md:text-[24px] text-[#717173] max-w-3xl mx-auto font-medium">
            Real-Time Collaboration, Coordination, and Communication Across
            Shared Spatial Environments
          </p>
        </div>
        <div className=" mt-5 md:mt-16 max-w-[1200px] w-full mx-auto">
          <div className="flex md:hidden mb-3 justify-end">
            <CarouselControls
              activeIndex={activeFeatureIndex}
              total={multiplayerTabFeature.length}
              onChange={setActiveFeatureIndex}
            />
          </div>
          <div className="w-full flex items-center justify-center aspect-[16/9] bg-[#1A1C20] rounded-[10px] border border-gray-800 overflow-hidden">
            {multiplayerTabFeature[activeFeatureIndex]?.video ? (
              <video
                key={multiplayerTabFeature[activeFeatureIndex].video} // Key forces re-render on change
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
              >
                <source
                  src={multiplayerTabFeature[activeFeatureIndex].video}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <div className="text-gray-500">No video available</div>
            )}
          </div>
        </div>
      </section>

      {/* FEATURE TABS SECTION */}
      <section className=" pb-10 w-full max-w-[1260px] mx-auto px-8 lg:px-8">
        <FeatureTabs
          title="Core Multiplayer Features"
          desc="Key functionality that enables real-time collaboration in shared mixed realities."
          features={multiplayerTabFeature}
          showImage={false}
          gridCols="md:grid-cols-3"
          containerClassName=""
          activeIndex={activeFeatureIndex}
          onTabChange={setActiveFeatureIndex}
        />
      </section>

      {/* MAIN FEATURES GRID */}
      <section className="px-8 w-full max-w-[1500px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-[#D8D8D8] font-jakarta">
            Bridge the Grid. Share the Moment.
          </h2>
          <p className="text-[#717173] max-w-4xl mx-auto text-[18px] md:text-[24px] font-medium">
            Whether it's AR, VR, or MR—structured using a spatial grid system.
            The grid serves as a foundational layer that maps and anchors
            content, interactions, and user positions across space and time.
          </p>
        </div>

        <div className="w-full grid xl:px-[8%] grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-2 md:gap-4  my-7 lg:gap-10">
          {multiplayerData.map((feature, index) => (
            <SuperChargeCard
              key={index}
              img={feature.img}
              title={feature.title}
              desc={feature.description}
            />
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 max-w-[1300px]">
        <CTABanner
          welcomeText="Ready to power real-time collaboration in XR?"
          description="Bring people together inside shared mixed realities. Spatial Grid Multiplayer enables real-time collaboration, synchronized interactions, and connected immersive experiences."
          buttonText="Get Started"
          onButtonClick={() => setShowSignupModal(true)}
        />
      </section>
      <SignupModal
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
      />
    </div>
  );
}
